import { styled } from '@material-ui/core';

export const NkInputError = styled('div')(({ theme }) => ({
  marginTop: '4px',
  color: theme.palette.error.main,
  fontSize: '12px',
  lineHeight: '10px',
  minHeight: '10px',
  fontWeight: 600,
}));
